import {Component} from '@angular/core';
import {APP_CONFIG} from '../../app.config';

@Component({
    selector: 'core-login-footer',
    templateUrl: './login-footer.component.html',
    styles: [],
    standalone: false,
})
export class LoginFooterComponent {
    copyright: string = APP_CONFIG?.copyright || '';
}
